

export const FETCH_USERS_REQUEST = 'users/FETCH_USERS_REQUEST';
export const FETCH_USERS_SUCCESS = 'users/FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILURE = 'users/FETCH_USERS_FAILURE';


export const FETCH_ROLES_REQUEST = 'users/FETCH_ROLES_REQUEST';
export const FETCH_ROLES_SUCCESS = 'users/FETCH_ROLES_SUCCESS';
export const FETCH_ROLES_FAILURE = 'users/FETCH_ROLES_FAILURE';


export const DELETE_USER_REQUEST = 'users/DELETE_USER_REQUEST';
export const DELETE_USER_SUCCESS = 'users/DELETE_USER_SUCCESS';
export const DELETE_USER_FAILURE = 'users/DELETE_USER_FAILURE';


export const CREATE_USER_REQUEST = 'users/CREATE_USER_REQUEST';
export const CREATE_USER_SUCCESS = 'users/CREATE_USER_SUCCESS';
export const CREATE_USER_FAILURE = 'users/CREATE_USER_FAILURE';


export const UPDATE_USER_REQUEST = 'users/UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'users/UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILURE = 'users/UPDATE_USER_FAILURE';

export const UPDATE_USER_PASSWORD_REQUEST = 'users/UPDATE_USER_PASSWORD_REQUEST';
export const UPDATE_USER_PASSWORD_SUCCESS = 'users/UPDATE_USER_PASSWORD_SUCCESS';
export const UPDATE_USER_PASSWORD_FAILURE = 'users/UPDATE_USER_PASSWORD_FAILURE';


export const FETCH_USER_REQUEST = 'users/FETCH_USER_REQUEST';
export const FETCH_USER_SUCCESS = 'users/FETCH_USER_SUCCESS';
export const FETCH_USER_FAILURE = 'users/FETCH_USER_FAILURE';


export const UPDATE_FIELD = 'users/UPDATE_FIELD';
export const SET_DEFAULT_DATA = 'users/SET_DEFAULT_DATA';
